module.exports = __webpack_public_path__ + "img/imagen_portada_video.c1579242.webp";